export default __webpack_public_path__ + "static/media/Nxrmal_Lo_Hoodie_BaseColor.ccce4ab7.tga";